import { ClipboardCheck } from "lucide-react";

const manifest = {
  key: "approvals_requests_management",
  isFreeModule: false,
  isPurchasable: true,
  icon: ClipboardCheck,
  names: {
    plan: {
      en: "Tender Approval Management",
      ar: "\u0625\u062f\u0627\u0631\u0629 \u0627\u0639\u062a\u0645\u0627\u062f \u0637\u0644\u0628\u0627\u062a \u0648\u0645\u0648\u0627\u0641\u0642\u0627\u062a \u0627\u0644\u0645\u0646\u0627\u0641\u0633\u0627\u062a",
      "zh-Hans": "审批与请求管理",
    },
    dashboard: {
      en: "Tender Approval Management",
      ar: "\u0625\u062f\u0627\u0631\u0629 \u0627\u0639\u062a\u0645\u0627\u062f \u0637\u0644\u0628\u0627\u062a \u0648\u0645\u0648\u0627\u0641\u0642\u0627\u062a \u0627\u0644\u0645\u0646\u0627\u0641\u0633\u0627\u062a",
      "zh-Hans": "审批仪表板",
    },
  },
  defaultPath: "/approvals-dashboard",
  matchers: [
    /^\/approvals-dashboard(?:\/|$)/,
    /^\/incoming-participation-requests(?:\/|$)/,
    /^\/tender-approvals(?:\/|$)/,
  ],
  buildNavbarMenus: ({ t, activeModuleLabel }) => [
    {
      label: activeModuleLabel,
      path: "__approvals_requests__",
      children: [
        { label: t("dashboard"), path: "/approvals-dashboard" },
        {
          label: t("incomingParticipationRequests"),
          path: "/incoming-participation-requests",
          permissions: ["publish_tender"],
        },
        {
          label: t("menu_tender_approvals") || "Tender Approvals",
          path: "/tender-approvals",
          permissions: ["publish_tender"],
        },
      ],
    },
  ],
};

export default manifest;
